// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1SdWH","content":"Footer_content__2bAkW","column":"Footer_column__5Lk7N","grey":"Footer_grey__3KklL","title":"Footer_title__17dY5"};